import { observer } from 'mobx-react';
import AdvancedListPage from '@product-framework/components/AdvancedListPage';
import { IconLibrary } from '@product-framework/index';

import {
  phoneNumber,
  status,
  lastAssignedAt,
  createdDateTime,
} from './accessorFunctions';
import { listSchema, searchSchema } from '../../schemas';
import validationSchema from './validations';

const config = {
  storeName: 'ManagedNumberList',
  apiPathSuffix: '/sxcl/v1/insights/managed-numbers',
  breadcrumb: {
    id: 'LIST_MANAGED_NUMBERS',
    defaultMessage: 'List Managed Numbers',
    icon: IconLibrary.Phone,
  },
  searchHeading: {
    id: 'SEARCH_MANAGED_NUMBERS',
    defaultMessage: 'Search Managed Numbers',
  },
  listHeading: {
    id: 'MANAGED_NUMBERS',
    defaultMessage: 'Managed Numbers',
  },
  accessorFunctions: {
    phoneNumber,
    status,
    lastAssignedAt,
    createdDateTime,
  },
  listSchema,
  searchSchema,
  validationSchema,
};

function ManagedNumberList() {
  return <AdvancedListPage {...config} />;
}

export default observer(ManagedNumberList);
